export default "__VITE_ASSET__B$UYMmiY__"